<form *ngIf="form" [formGroup]="form">
  <div>
    <span class="label-box">{{ localizeBasePath + '.password_recovery' | localize }}</span>
    <button
      class="k-button-icon k-button k-bare app-close-button"
      style="margin-left: 1em"
      (click)="goToLoginPage()"
      title="{{ 'profile.default.close' | localize }}"
    >
      <span class="k-icon k-i-close ng-star-inserted"></span>
    </button>
  </div>
  <div *ngIf="!formCodeShowed" class="data-box">
    <kendo-formfield class="field-group">
      <kendo-floatinglabel class="required" text="{{ 'profile.default.phone' | localize }}">
        <kendo-maskedtextbox
          formControlName="login"
          (keydown.enter)="showCheckFormCode()"
          required
        ></kendo-maskedtextbox>
      </kendo-floatinglabel>
    </kendo-formfield>
    <button [disabled]="isGetCodeBtnDisabled" kendoButton (click)="showCheckFormCode()">
      {{ 'profile.default.get_code' | localize }}
    </button>
  </div>

  <div *ngIf="formCodeShowed" class="data-box">
    <kendo-formfield class="field-group">
      <kendo-floatinglabel class="required" text="{{ localizeBasePath + '.new_password' | localize }}">
        <kendo-textbox #passwordbox formControlName="password" [clearButton]="true">
          <ng-template kendoTextBoxSuffixTemplate>
            <button kendoButton look="clear" iconClass="k-icon fas fa-eye" (click)="toggleVisibility()"></button>
          </ng-template>
        </kendo-textbox>
      </kendo-floatinglabel>
      <kendo-formerror *ngIf="getErrorOfField('password', 'required') as error">
        {{ defaultErrors.required(error) }}
      </kendo-formerror>
      <kendo-formerror *ngIf="getErrorOfField('password', 'minlength') as error">
        {{ defaultErrors.minlength(error) }}
      </kendo-formerror>
    </kendo-formfield>

    <kendo-formfield class="field-group">
      <kendo-floatinglabel class="required" text="{{ 'profile.default.hint_code' | localize }}">
        <kendo-textbox formControlName="code"></kendo-textbox>
      </kendo-floatinglabel>
    </kendo-formfield>

    <button [disabled]="isSendBtnDisabled" kendoButton (click)="recovery()">
      <span class="k-icon k-i-loading" *ngIf="fetching; else staticText"></span>
      <ng-template #staticText>{{ localizeBasePath + '.restore' | localize }}</ng-template>
    </button>
    <ng-container *ngIf="countdown$ | async as value; else resend">
      {{ 'profile.default.hint_countdown' | localize }} {{ value }} {{ 'profile.default.sec' | localize }}
    </ng-container>
    <ng-template #resend>
      <button (click)="showCheckFormCode()" kendoButton>{{ 'profile.default.resend' | localize }}</button>
    </ng-template>
  </div>
</form>
